import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { DataGrid, Column } from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';
import { OrderSummary } from '../../../types/types.orders';
import { LoadPanel } from 'devextreme-react/load-panel';
import { useScreenSize } from '../../../utils/media-query';

export const ModalOrdersSummary = ({ visible, loading, data, onClose }: { visible: boolean; loading: boolean; data: OrderSummary[]; onClose: () => void }) => {
  const { isSmall, isMedium, isXSmall } = useScreenSize();
  return (
    <Popup visible={visible} onHiding={onClose} dragEnabled={true} showCloseButton={false} showTitle={true} title='Resumen de Órdenes Creadas' width={700} fullScreen={isSmall || isMedium || isXSmall} height={400}>
      {loading ? (
        <LoadPanel visible={loading} showIndicator={true} shading={false} showPane={false} hideOnOutsideClick={false} />
      ) : (
        <DataGrid dataSource={data} showBorders={true} columnAutoWidth={true} rowAlternationEnabled={true}>
          <Column dataField='Success' caption='Estado' width={100} cellRender={renderSuccessIcon} alignment='center' />
          <Column dataField='IdPreorden' caption='Preorden' width={100} alignment='center' />
          <Column dataField='OrderNumber' caption='Número de Orden' width={150} alignment='center' />
          <Column dataField='Message' caption='Mensaje' />
        </DataGrid>
      )}
      <ToolbarItem toolbar='bottom' location='after'>
        <div className={`form-popup-buttons-container`}>
          <Button text={loading ? 'Creando... ' : 'Cerrar'} stylingMode='contained' onClick={onClose} disabled={loading} />
        </div>
      </ToolbarItem>
    </Popup>
  );
};

// Renderizador personalizado para la columna "Éxito"
const renderSuccessIcon = ({ value }: { value: boolean }) => {
  return <div style={{ textAlign: 'center' }}>{value ? <span style={{ color: 'green', fontSize: '18px' }}>✔ </span> : <span style={{ color: 'red', fontSize: '18px' }}>✖</span>}</div>;
};
